import classes from "~/OrdersQuotes/OrderDetailsPage/components/ServiceCases/ServiceCasesTable.module.less";
import { t } from "i18next";
import { LinkButton } from "~/common/components/Link";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";

interface Params {
  openPopup: () => void;
}

export const CreateCaseElement = ({ openPopup }: Params) => {
  return (
    <div className={classes.labelContainer}>
      <p>{t("serviceCases.addCase.label")}</p>
      <LinkButton onClick={openPopup} iconBefore={<Icon type={IconType.Plus} />}>
        {t("serviceCases.addCase.button")}
      </LinkButton>
    </div>
  );
};
